import { Button, AlertDialog } from '@buffer-mono/popcorn'

type DiscardReplyDialogProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  onDiscard: () => void
  onKeepWriting: () => void
}

export const DiscardReplyDialog = ({
  open,
  onOpenChange,
  onDiscard,
  onKeepWriting,
}: DiscardReplyDialogProps): JSX.Element => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialog.Content>
        <AlertDialog.Title>Are you sure?</AlertDialog.Title>
        <AlertDialog.Description>
          Your unsent reply will be lost permanently.
        </AlertDialog.Description>
        <AlertDialog.Actions>
          <AlertDialog.Cancel onClick={onKeepWriting}>
            <Button variant="tertiary">Keep writing</Button>
          </AlertDialog.Cancel>
          <AlertDialog.Action onClick={onDiscard}>
            <Button variant="critical">Discard reply</Button>
          </AlertDialog.Action>
        </AlertDialog.Actions>
      </AlertDialog.Content>
    </AlertDialog>
  )
}
